import request from "@/utils/request";

export function tokenLogin(data) {
  return request({
    url: "/v3/iw-framework/login/refreshToken2",
    method: "post",
    data: { data: { refreshToken: data } }
  });
}

export function simpleLogin(data) {
  return request({
    url: "/v3/iw-framework/login/simpleLogin",
    method: "post",
    data: { data }
  });
}

export function modifyPassword(data) {
  return request({
    url: "/v3/iw-framework/login/updatePwd",
    method: "post",
    data: { data }
  });
}

export function dynamicLogin(data) {
  return request({
    url: "/v3/iw-framework/login/dynamicLogin",
    method: "post",
    data: { data }
  });
}

export function qrcodeLogin(data) {
  return request({
    url: "/v3/iw-framework/login/qrcodeLogin",
    method: "post",
    data: { data }
  });
}

//
export function resetPassword(data) {
  return request({
    url: "/v3/iw-framework/login/reset-password",
    method: "post",
    data: {
      data
    }
  });
}

export function logout() {
  return request({
    url: "/v3/iw-framework/login/logout",
    method: "post",
    data: { data: {} }
  });
}

export function getInfo() {
  return request({
    url: "/cas-server/info",
    method: "get"
  });
}

export function refreshToken(data) {
  return request({
    url: "/v3/iw-framework/login/refreshToken",
    method: "post",
    data: { data }
  });
}
